import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { UserService } from '../../../services/http/user.service';
import * as NotificationActions from '../../global-notification/actions/global-notification.action';
import * as InvitationActions from '../actions/invitations.actions';
import * as ClientActions from '../../client/actions/client.actions';
import { ClientFacade } from '../../client/facade/client.facade';
import { SnackBarService } from 'src/app/services/snackbar/snackBar.service';

@Injectable()
export class InvitationEffects {

    constructor(private actions$: Actions, 
        private userService: UserService, 
        private clientFacade: ClientFacade,
        private snackbarService: SnackBarService) {
    }

    GetUserInvitations$ = createEffect(() => this.actions$
        .pipe(
            ofType(InvitationActions.GET_USER_INVITATIONS),
            switchMap((action: InvitationActions.GetUserInvitations) => {
                return this.userService.getUserInvitations()
                    .pipe(
                        map((res: any[]) => {
                            return new InvitationActions.GetUserInvitationsSuccess(res);
                        })
                        , catchError((err) => {
                            return of(
                                new InvitationActions.GetUserInvitationsFailure(err)
                            );
                        })
                    );
            }),
        ));

    AcceptUserInvitation$ = createEffect(() => this.actions$
        .pipe(
            ofType(InvitationActions.ACCEPT_USER_INVITATION),
            mergeMap((action: InvitationActions.AcceptUserInvitation) => {
                return this.userService.acceptUserInvitation(action.payload)
                    .pipe(
                        mergeMap(() => {
                            this.snackbarService.showSnackBar("Successfully accepted user invitation")
                            return of(
                                new InvitationActions.AcceptUserInvitationSuccess(),
                            )
                        })
                        , catchError((err) => {                    
                            const error = (err && err.error.message) ? err.error.message : 'Failed to accept invitation. Please try again.';
                            this.snackbarService.showWarningSnackBar(error);
                            return EMPTY;
                        })
                    );
            }),
        ));

    RejectUserInvitation$ = createEffect(() => this.actions$
        .pipe(
            ofType(InvitationActions.REJECT_USER_INVITATION),
            mergeMap((action: InvitationActions.RejectUserInvitation) => {
                return this.userService.rejectUserInvitation(action.payload)
                    .pipe(
                        mergeMap((res: any) => {
                            return of(
                                new InvitationActions.RejectUserInvitationSuccess(),
                                new NotificationActions.NotificationSuccessAction("Successfully declined user invitation")
                            )
                        })
                        , catchError((err) => {
                            const error = (err && err.error.message) ? err.error.message : 'Failed to decline invitation. Please try again.';
                            return of(
                                new NotificationActions.NotificationErrorAction(error)
                            );
                        })
                    );
            }),
        ));

    UserInvitationActionSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(
            InvitationActions.REJECT_USER_INVITATION_SUCCESS,
            InvitationActions.ACCEPT_USER_INVITATION_SUCCESS
        ),
        switchMap(() => {
            return of(
                new InvitationActions.GetUserInvitations()
            );
        })
    ));

    AcceptUserInvitationSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(
            InvitationActions.ACCEPT_USER_INVITATION_SUCCESS
        ),
        map(() => {
            //If we have just accepted an invitation we want to reload the client data to see the newly accessible investor
            //Because the reload client investor method needs to be aware of state (general selection date) we cant just dispatch the action
            //from here so return an empty action
            return new ClientActions.GetClientInvestorEntities(this.clientFacade.selectedDate);
        })
    ));
}